export const ORGANIZATION_ADMINISTRATOR = 'OrganizationAdministrator';
export const SYSTEM_USER_ID = 'ffffffff-ffff-ffff-ffff-ffffffffffff';
